module.exports = ".holder {\n  background: #424242;\n  position: absolute;\n  top: 0;\n  height: 100vh;\n  width: 156px;\n  z-index: 1000;\n  -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\n          box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\n}\n\n.holder.left {\n  left: 0;\n}\n\n.holder.right {\n  right: 0;\n}\n\n.inner {\n  position: absolute;\n  top: 16px;\n  bottom: 16px;\n  left: 16px;\n  right: 16px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/bar/bar.component.css
// module id = ./src/app/components/editor/bar/bar.component.css
// module chunks = main